export enum ApplicationType {
	Deposit = 'Deposit',
	Loan = 'Loan',
}